import {trangThaiTraThuocOptions} from "assets/constants/kbnt-category";
import {listBacSy1} from "data/list";

import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {DataFormField} from "types/models/input-field-type";

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 24, lg: 12, xl: 12};

export const fieldsInforDetail1: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày tạo",
    name: "ngayTao",

    optionsTime: {
      showTime: false,
      format: FORMAT_TIME.dayFull,
    },
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoai",
    placeholder: "",
    disable: true,
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChiTongHop",
    placeholder: "",
    disable: true,
  },
  {
    type: INPUT,
    label: "Thân nhân",
    name: "hoTenThanNhan",
    placeholder: "",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Loại KCB",
    name: "loaiKCB",
    placeholder: "",
    disable: true,
    options: JSON.parse(localStorage.getItem("loaiKCB")) || [],
  },
  {
    type: INPUT,
    label: "Lý do khám",
    name: "lyDoKham",
    placeholder: "",
    disable: true,
  },
  {
    type: INPUT,
    label: "Dị ứng",
    name: "diUng",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái tra thuốc",
    name: "trangThaiTraThuoc",
    placeholder: "",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "BS Khám",
    name: "bacSyKham",
    placeholder: "Chọn",
    // options: listBacSy1,
  },
  {
    type: COMBO_BOX,
    label: "Chuyển phòng",
    name: "phong",
    placeholder: "",
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái KBNT",
    name: "trangThai",
    placeholder: "",
    disable: true,
  },
];

export const fieldsInforDetail2: Array<DataFormField> = [
  // {
  //   type: INPUT,
  //   label: "Thông tin SLCB",
  //   name: "slcb",
  //   disable: true,
  //   css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 16},
  //   wrapperCol: {xs: 14, md: 16, lg: 20, xl: 20},
  //   labelCol: {xs: 10, md: 8, lg: 4, xl: 4},
  // },
];
